<template>
  <div
    class="lang-select-container custom-lang-select"
    v-if="currentLanguage"
    @click="toggleDropdown"
  >
    <div class="lang-dropdown" @blur="isOpen = false">
      <div class="lang-dropdown-selected" ref="dropdownSelected">
        <div class="">
          {{ currentLanguageName }}
        </div>
        <span class="lang-dropdown-arrow" :class="{ 'arrow-up': isOpen }"
          >▾</span
        >
      </div>
      <transition name="fade">
        <div v-if="isOpen" class="lang-dropdown-menu">
          <div
            v-for="lang in allLanguages"
            :key="lang.id"
            class="desc small lang-dropdown-item"
            @click.stop="selectLanguage(lang.id)"
          >
            {{ lang.title }}
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    ...mapGetters("app", [
      "currentLanguageName",
      "currentLanguage",
      "allLanguages",
    ]),
  },
  methods: {
    ...mapActions("app", ["changeLocale"]),
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    selectLanguage(langId) {
      this.changeLocale(langId);
      this.isOpen = false;
      this.$parent.getTextPages();
      if (this.$route.name == "TextPage") {
        this.$parent.getTextPageContent(this.$route.params.id);
      }
    },
    closeDropdown(event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false;
      }
    },
    handleScroll() {
      this.isOpen = false;
    },
  },
  mounted() {
    document.addEventListener("click", this.closeDropdown);
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeDropdown);
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
.lang-select-container {
  width: fit-content;
  margin-right: 16px;
  border: 1px solid #22a8fd;
  border-radius: 20px;
  line-height: 26px;
  padding: 6px 18px;
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: #22a8fd;
  background: #f9f9f9;
  outline: none;
  transition: border 0.2s;
  cursor: pointer;
  margin-right: 12px;
  position: relative;
}

.lang-dropdown {
  cursor: pointer;
  user-select: none;
}

.lang-dropdown-selected {
  background-color: transparent;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.lang-dropdown-selected .desc {
  color: #282e38;
}
.lang-dropdown-arrow {
  margin-left: 10px;
  color: #666;
  user-select: none;
  font-size: 0;
  width: 10px;
  height: 10px;
  top: 50%;
  right: 0;
  position: relative;
}

.lang-dropdown-menu {
  position: absolute;
  left: 0;
  top: 110%;
  background: #e7ecf1;
  border-radius: 10px;
  border: 1px solid #c9d0d7;
  width: 100%;
  z-index: 1000;
  color: #282e38;
  padding: 8px 12px;
  border-radius: 10px;
}

.lang-dropdown-item.desc {
  padding: 8px 0;
  cursor: pointer;
  transition: background-color 0.2s ease;
  color: #282e38;
}

.lang-dropdown-arrow.arrow-up {
  transform: rotate(-180deg);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
